import React from 'react';
import { useSelector } from 'react-redux';

const useDocumentSelectors = () => {
  const filterVisible = useSelector(
    (store) => store.documentsStore.filterVisible
  );
  const dateRangeField = useSelector(
    (store) => store.documentsStore.dateRangeField
  );
  const dateRange = useSelector((store) => store.documentsStore.dateRange);
  const valueType = useSelector((store) => store.documentsStore.valueType);
  const valueSubType = useSelector(
    (store) => store.documentsStore.valueSubType
  );
  const valueStatus = useSelector((store) => store.documentsStore.valueStatus);
  const filterStatus = useSelector(
    (store) => store.documentsStore.filterStatus
  );
  const valueServiceCompany = useSelector(
    (store) => store.documentsStore.valueServiceCompany
  );
  const valueExecuter = useSelector(
    (store) => store.documentsStore.valueExecuter
  );
  const valueCreator = useSelector(
    (store) => store.documentsStore.valueCreator
  );
  const responsibleWorker = useSelector(
    (store) => store.documentsStore.responsibleWorker
  );
  const valueCompany = useSelector(
    (store) => store.documentsStore.valueCompany
  );
  const valueAddrStreet = useSelector(
    (store) => store.documentsStore.valueAddrStreet
  );
  const valueAddrBuilding = useSelector(
    (store) => store.documentsStore.valueAddrBuilding
  );
  const listAddrBuilding = useSelector(
    (store) => store.documentsStore.listAddrBuilding
  );
  const valueAddrFlat = useSelector(
    (store) => store.documentsStore.valueAddrFlat
  );
  const listAddrFlat = useSelector(
    (store) => store.documentsStore.listAddrFlat
  );
  const selectedDateRange = useSelector(
    (store) => store.documentsStore.selectedDateRange
  );
  const viewOtherDocs = useSelector(
    (store) => store.documentsStore.viewOtherDocs
  );

  return (
    {
      viewOtherDocs,
      filterVisible,
      dateRangeField,
      dateRange,
      valueType,
    valueSubType,
      valueStatus,
      filterStatus,
      valueServiceCompany,
      valueExecuter,
      valueCreator,
      responsibleWorker,
      valueCompany,
      valueAddrStreet,
      valueAddrBuilding,
      valueAddrFlat,
      listAddrBuilding,
      listAddrFlat,
      selectedDateRange
    }
  );
};

export default useDocumentSelectors;